import React from "react";
import { Reveal } from "../../lib/motion";
import { KpiCard } from "./KpiCard";

const Problem = () => {
  return (
    <section
      id="about"
      data-testid="problem-section"
      className="relative py-24 md:py-32 lg:py-40 jsc-gridlines-none"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24">
        <Reveal>
          <p className="font-body text-xs uppercase tracking-[0.24em] text-[#B39B77] mb-4">
            01 / The Reality
          </p>
          <div className="hidden md:block h-px w-16 bg-[#1C1C1E]/20" />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <h2 className="font-display font-semibold text-[#1C1C1E] text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
                You have the data.
                <br />
                <span className="text-[#3E4A5C]">You just can&apos;t see it.</span>
              </h2>
            </Reveal>

            <Reveal delay={0.2}>
              <p className="mt-8 max-w-xl font-body text-lg md:text-xl leading-relaxed text-[#3E4A5C]">
                Every fashion retailer sits on a goldmine — years of sales, inventory
                movement and product performance. But it&apos;s scattered across spreadsheets,
                billing software and gut feel. So the big calls get made on instinct.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-5 flex lg:justify-end">
            <KpiCard />
          </div>
        </div>

        <Reveal delay={0.2}>
          <div className="mt-16 md:mt-20 grid grid-cols-1 sm:grid-cols-3 gap-8 border-t border-[rgba(28,28,30,0.1)] pt-10">
            {[
              { k: "Discounts", v: "When to mark down — and by how much — without killing margin." },
              { k: "Restocking", v: "What&apos;s about to sell out and what&apos;s quietly gathering dust." },
              { k: "Bundling", v: "Which products actually sell better together, and which don&apos;t." },
            ].map((item, i) => (
              <div key={i} data-testid={`problem-item-${i}`}>
                <p className="font-display text-xl text-[#1C1C1E] mb-2">{item.k}</p>
                <p
                  className="font-body text-sm leading-relaxed text-[#3E4A5C]"
                  dangerouslySetInnerHTML={{ __html: item.v }}
                />
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Problem;
